import { ResourceNotFoundError } from '../../sdk/errors';
import { withErrorParsing } from '../../dialect-cloud-api/data-service-errors';
export class DappsImpl {
    constructor(dappAddresses, dappMessages, notificationTypes, notificationSubscriptions, dappsApi) {
        this.dappAddresses = dappAddresses;
        this.dappMessages = dappMessages;
        this.notificationTypes = notificationTypes;
        this.notificationSubscriptions = notificationSubscriptions;
        this.dappsApi = dappsApi;
    }
    async find() {
        try {
            const dappDto = await withErrorParsing(this.dappsApi.find());
            return this.toDapp(dappDto);
        }
        catch (e) {
            const err = e;
            if (err instanceof ResourceNotFoundError)
                return null;
            throw e;
        }
    }
    toDapp(dappDto) {
        return new DappImpl(dappDto.id, dappDto.publicKey, dappDto.name, dappDto.verified, dappDto.telegramBotUserName, dappDto.blockchainType, this.dappAddresses, this.dappMessages, this.notificationTypes, this.notificationSubscriptions, dappDto.description, dappDto.websiteUrl, dappDto.avatarUrl, dappDto.heroUrl);
    }
    async findAll(query) {
        const dappDtos = await withErrorParsing(this.dappsApi.findAll(query));
        return dappDtos.map((it) => ({
            id: it.id,
            address: it.publicKey,
            name: it.name,
            description: it.description,
            websiteUrl: it.websiteUrl,
            avatarUrl: it.avatarUrl,
            heroUrl: it.heroUrl,
            verified: it.verified,
            telegramUsername: it.telegramBotUserName,
            blockchainType: it.blockchainType,
        }));
    }
    async create(command) {
        const dappDto = await withErrorParsing(this.dappsApi.create({
            name: command.name,
            description: command.description,
            websiteUrl: command.websiteUrl,
            avatarUrl: command.avatarUrl,
            heroUrl: command.heroUrl,
            telegramBotConfiguration: command.telegramBotConfiguration,
            blockchainType: command.blockchainType,
        }));
        return this.toDapp(dappDto);
    }
}
export class DappImpl {
    constructor(id, address, name, verified, telegramUsername, blockchainType, dappAddresses, messages, notificationTypes, notificationSubscriptions, description, websiteUrl, avatarUrl, heroUrl) {
        this.id = id;
        this.address = address;
        this.name = name;
        this.verified = verified;
        this.telegramUsername = telegramUsername;
        this.blockchainType = blockchainType;
        this.dappAddresses = dappAddresses;
        this.messages = messages;
        this.notificationTypes = notificationTypes;
        this.notificationSubscriptions = notificationSubscriptions;
        this.description = description;
        this.websiteUrl = websiteUrl;
        this.avatarUrl = avatarUrl;
        this.heroUrl = heroUrl;
    }
}
//# sourceMappingURL=dapp.js.map